import texts from './texts.json';

const generateMessageId = () => `msg-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;

const getStepFolder = (index) => `message${index}`;

const getDefaultPlaceholder = (index) => (index === 0 ? texts.step1DefaultMessage : texts.step2DefaultMessage);

// Attachments in this feature are stored as `{ url: <storagePath>, name }`.
// These helpers normalize that shape (and tolerate partial/undefined objects from UI state).
const getAttachmentUrl = (att) => (att?.url || '').trim();

const getAttachmentName = (att) => att?.name || getAttachmentUrl(att);

const normalizeAttachmentRef = (att) => {
  const url = getAttachmentUrl(att);
  if (!url) return null;
  return { url, name: getAttachmentName(att) || url };
};

// Convenience for building a fast lookup map (used for orphan deletion + labeling errors).
const buildUrlNameMap = (attachments) => new Map(
  (attachments || [])
    .map(normalizeAttachmentRef)
    .filter(Boolean)
    .map(({ url, name }) => [url, name]),
);

const toMessageShape = (m) => ({
  id: generateMessageId(),
  message: m.message || '',
  enabled: m.enabled !== undefined ? !!m.enabled : true,
  fileAttachments: [],
});

const getDefaultMessages = (data) => (
  data.length === 0 ? [{ ...toMessageShape({}), enabled: true }] : data.map(toMessageShape)
);

const buildMessagesWithAttachmentsFromResults = (data, results) => data.map((m, i) => ({
  ...toMessageShape(m),
  // Hide attachments that failed to load (see `initStepAttachments`).
  fileAttachments: (results[i] || []).filter((f) => !f.loadFailed),
}));

const safeMessages = (arr) => (arr.length ? arr : getDefaultMessages([]));

const hasMessageContent = (m) => (m.message?.trim() || '').length > 0 || (m.fileAttachments?.length || 0) > 0;

export {
  getStepFolder,
  getDefaultPlaceholder,
  getDefaultMessages,
  buildMessagesWithAttachmentsFromResults,
  safeMessages,
  hasMessageContent,
  toMessageShape,
  getAttachmentUrl,
  getAttachmentName,
  normalizeAttachmentRef,
  buildUrlNameMap,
};
